import React from 'react';

function Privacy() {
  return (
    <main className="bg-grid min-h-screen">
      <section className="mx-auto max-w-4xl px-6 pb-16 pt-28 lg:px-10">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-accent/90">Privacy</p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-white sm:text-4xl">Privacy Policy</h1>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg">
          At Merchy, we respect your privacy and treat business information with care.
        </p>
        <div className="mt-6 rounded-2xl border border-white/10 bg-card/70 p-5 text-base text-white">
          <p className="font-semibold">We do not sell, rent, or share customer data with third parties.</p>
          <p className="mt-2 font-semibold">We use information only to communicate with you and deliver agreed work.</p>
        </div>

        <div className="mt-10 space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-white">Information We Collect</h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">
              Contact details you submit, business details you choose to share, and project information needed to
              understand your workflow, proposal, or support request.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">How We Use Information</h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">
              We use information to respond to inquiries, prepare proposals, build and support software or automation
              projects, and improve our service quality.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">Project Data</h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">
              If a project requires access to business systems, files, or operational data, access is handled based on
              the scope agreed with you and limited to what is required for the work.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">Third-Party Services</h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">
              Some projects may use hosting, analytics, messaging, email, database, automation, or API providers. We
              choose services according to the project requirements and discuss relevant setup details when needed.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">Contact</h2>
            <p className="mt-2 text-sm text-gray-400">support@merchyapp.online</p>
          </section>
        </div>
      </section>
    </main>
  );
}

export default Privacy;
